import React, { useState, useEffect } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { useFixturesQuery } from 'api/feeds';
import Loader from '../loader';
import MatchCardCount from '../matchCardCount';
import MatchStatusTag from '../matchStatusTag';
import Fixture from '../fixture';
import Button from '../button';
import TotalPoints from '../totalPoints';
import Typo from '../typo';
import MatchCardDate from '../matchCardDate';
import MatchCardInfo from '../matchCardInfo';
import PickedPlayer from '../pickedPlayer';
import { getCookie } from 'utils/commonFunctions';
import config from 'utils/config';
import { useGetOverviewTeamQuery, useGetTeamCreatedGamedaysQuery } from 'api';
import TeamDetail from '../teamDetail';
import { useSelector } from 'react-redux';

const MatchCard = ({
  showCTA = false,
  openEvent,
  matchesData,
  matchgameid,
  hideTimer,
  updatedMatches,
  teamGamedayIds,
  overviewTeam,
  showPostCard,
  totalGdPoints,
  lateOnboard,
  matches
}) => {
  const navigate = useNavigate();
  const match = useMatch('/mypicks');
  const gameCookie = getCookie(config.gameCookieName);
  const finalmatch = matches?.filter((fix) => fix?.event_status_id == 0)?.length;
  const teams = overviewTeam?.teams || [];
  const selectedPlayers = teams
    .map((team) =>
      team.plyid.map((id, index) => ({
        id,
        skill_id: team.plyskill[index]
      }))
    )
    .flat();

  const formatMatchDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
    const month = date.toLocaleDateString('en-GB', { month: 'long' });
    const year = date.toLocaleDateString('en-GB', { year: 'numeric' });
    return `${day} ${month}, ${year}`;
  };

  // const gameDayIds = typeof(matchesData) === "Array" ? matchesData?.map((event) => event?.gameday_id) : matchesData?.gameday_id;
  const handleCreateTeamClick = (match) => {
    const matchData = {
      matchId: match?.match_id,
      home_team_id: match?.home_team_id,
      away_team_id: match?.away_team_id,
      gameday_id: match?.gameday_id,
      home_team_name: match?.home_team_name,
      away_team_name: match?.away_team_name,
      deadline: match?.deadline,
      match_number: match?.match_number,
      is_final_locked: match?.is_final_locked,
      event_status_id: match?.event_status_id,
      home_team_short_name: match?.home_team_short_name,
      away_team_short_name: match?.away_team_short_name,
      phase_id: match?.phase_id,
      match_status: match?.match_status
    };
    localStorage.setItem('openEvent', JSON.stringify(matchData));
    navigate('/createteam', { state: { match: matchData } });
  };
  const overviewApiData = useSelector((state) => state.createTeam.overviewApiData);
  return (
    <>
      {(matchesData || [])?.map((match) => {
        const teamA = { id: match?.home_team_id, name: match?.home_team_name };
        const teamB = { id: match?.away_team_id, name: match?.away_team_name };

        const overviewPointGd = overviewApiData?.gdpts?.find(
          (card) => card?.gdid == match?.gameday_id
        );

        const teamForGameday = overviewApiData?.teams?.find(
          (team) => team?.gdid === Number(match?.gameday_id)
        );

        const selectedPlayers = teams
          ?.filter((team) => team?.gdid == match?.gameday_id)
          ?.map((team) =>
            team?.plyid?.map((id, index) => ({
              id,
              skill_id: team?.plyskill[index]
            }))
          )
          .flat();

        const playerIdsForGameday = teamForGameday ? teamForGameday.plyid : [];

        return (
          <div className='si-matchCard' key={match?.match_id}>
            <div className='si-matchCard-head'>
              <div className='si-matchCard-head-wrap'>
                <MatchCardCount key={match?.match_id} matchcount={match?.match_number} />
                <MatchCardDate matchdate={formatMatchDate(match?.deadline)} />
              </div>
              <MatchStatusTag event={match} utcTime={match?.deadline} hideTimer={hideTimer} />
            </div>
            <div className='si-matchCard-body'>
              <div className='si-matchCard__fixtures'>
                <Fixture match={{ teamA, teamB }} />
              </div>
            </div>
            {showCTA && (
              <div className='si-matchCard-foot'>
                {finalmatch === 0 &&
                match?.event_status_id == 2 &&
                match?.is_final_locked == 1 &&
                !gameCookie ? (
                  <MatchCardInfo
                    transKey={'game_live_tournament_end'}
                    title={'The game is live, and the tournament has come to an end.'}
                  />
                ) : match?.event_status_id == 2 && !matchgameid && match?.is_final_locked == 0 ? (
                  <MatchCardInfo
                    transKey='game_live_reduce_points'
                    title={'*Game is Live, Pick your players with reduced points'}
                  />
                ) : match?.event_status_id == 2 && match?.is_final_locked == 1 && !gameCookie ? (
                  <MatchCardInfo
                    transKey='gane_live_next_match'
                    title={'Game is Live, Get ready to pick your team for the next match!'}
                  />
                ) : null}

                {/* Play as Guest Button */}
                {!gameCookie && !match?.is_final_locked ? (
                  <div className='si-matchCard-foot__cta'>
                    <Button
                      variant='primary'
                      transKey='cta_play_as_guest'
                      onClick={() => handleCreateTeamClick(match)}
                    >
                      Play as a Guest
                    </Button>
                  </div>
                ) : null}

                {gameCookie && !match.canViewPicks && match?.event_status_id != 5 && (
                  <div className='si-matchCard-foot__cta'>
                    {match.is_final_locked === 0 ? (
                      <Button
                        variant='primary'
                        transKey='cta_pick_your_team'
                        onClick={() => handleCreateTeamClick(match)}
                      >
                        Choose your Top Picks
                      </Button>
                    ) : (
                      <Typo
                        transKey={
                          match.is_final_locked === 1 ? 'no_player_picked' : 'selection_locked'
                        }
                        component='p'
                        className='no-players-message'
                      ></Typo>
                    )}
                  </div>
                )}

                {gameCookie && match.canViewPicks && match?.event_status_id != 5 ? (
                  <div className='si-matchCard-foot__cta'>
                    <PickedPlayer
                      title={
                        match?.event_status_id == 1
                          ? 'Edit Picks'
                          : match?.event_status_id == 2
                          ? 'View Picks'
                          : 'View Team'
                      }
                      handleButtonClick={() => {
                        handleCreateTeamClick(match);
                      }}
                      matchStstus={match?.event_status_id}
                      variant={'secondary'}
                      totalPoints={overviewPointGd?.gdpts}
                      playerIdsForGameday={playerIdsForGameday}
                      lateOnboard={teamForGameday?.is_late_onboarded_user}
                      img={selectedPlayers}
                    />
                  </div>
                ) : (
                  match?.event_status_id == 5 && (
                    <div className='si-matchCard-foot'>
                      <div className='si-matchCard-foot__cta'>
                        <div className='si-matchCard-foot__playerWrap'>
                          <div className='si-matchCard-foot__grid'>
                            <div className='si-matchCard-foot__gridLhs'>
                              <Typo component='p' className='si-totalPoints__title'>
                                MATCH ABANDONED
                              </Typo>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            )}

            {showPostCard && openEvent?.event_status_id != 1 && matchgameid ? (
              <div className='si-matchCard-foot'>
                <div className='si-matchCard-foot__cta'>
                  <div className='si-matchCard-foot__playerWrap'>
                    <div className='si-matchCard-foot__grid'>
                      <div className='si-matchCard-foot__gridLhs'>
                        <Typo component='p' className='si-totalPoints__title'>
                          Total points
                        </Typo>
                      </div>
                      <div className='si-matchCard-foot__gridRhs'>
                        <TotalPoints
                          totalPoints={totalGdPoints}
                          addCls={'si-totalPoints__wrap--cta'}
                          lateOnboard={lateOnboard}
                          // hideIcon={true}
                          // onClick={handleButtonClick}
                          // hideIcon={true}
                          // onClick={handleButtonClick}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        );
      })}
    </>
  );
};

export default MatchCard;
